import React, { useRef, useState, useEffect } from 'react';
import Webcam from "react-webcam";
import styles from "../../ExternalDash/Verifier/Records.module.css";
import API from "../../../../ApiConfig";
import { useLocation, useNavigate } from 'react-router-dom';
import { VERIFY_FACE } from '../../../../Utils/constant';
import Loader from '../../../../components/Loader';
import cogoToast from 'cogo-toast-react-17-fix';
import style from "../../../OnBoarding/UserOnboarding2.module.css";

const FaceMatch = () => {
    const webcamRef = useRef(null);
    const [captureImg, setCaptureImg] = useState("");
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const shared_data_id = location?.state?.shared_data_id;
    const [verified, setVerified] = useState(false);
    const navigate = useNavigate();
    const [faceScanned, setFaceScanned] = useState(false);

    const handleFaceMatch = () => {
        const image = captureImg.split(",")[1]; // Extract base64 image data
        const formData = {
            form_image: image,
            shared_data_id: shared_data_id
        };

        setLoading(true);
        API.post(VERIFY_FACE, formData)
            .then(res => {
                setLoading(false);
                cogoToast.success(res.data.data.message);
                setVerified(true);
                setTimeout(() => {
                    navigate("/dashboard/forms/myRequests");
                }, 2000);
            })
            .catch(err => {
                setLoading(false);
                cogoToast.error(err?.response?.data?.message);
                // console.log(err);
            });
    };

    const captureImage = () => {
        if (webcamRef.current) {
            const imgSrc = webcamRef.current.getScreenshot(); // Capture image
            setCaptureImg(imgSrc);
            setFaceScanned(true);
        }
    };

    return (
        <>
            {!verified ? (
                <>
                    <Loader loading={loading} />
                    <div className={styles.qrContainer}>
                        <div className={styles.qrText}>Verify your face</div>
                        <div className={styles.qrSubText}>Scan face to verify if the user is the same</div>
                        {!faceScanned ? (
                            <>
                                <Webcam
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/png"
                                    videoConstraints={{ facingMode: "user" }}
                                    className={styles.qrScanner}
                                />
                                <button className='btn btn-primary' onClick={captureImage}>Capture Image</button>
                            </>
                        ) : (
                            <>
                                {loading ? "Processing....." : ""}
                                <img src={captureImg} alt='Captured Face' className={styles.qrScanner} />
                                <div>
                                    <button className='btn btn-primary' onClick={() => { setFaceScanned(false); setCaptureImg(""); }}>Retake</button>
                                    <button className='btn btn-primary' onClick={handleFaceMatch}>Continue</button>
                                </div>
                            </>
                        )}
                    </div>
                </>
            ) : (
                <div className={styles.qrContainer}>
                    <div className={styles.form}>
                        <div className={style.form1}>
                            <div className={style.iconHeading}>
                                <img className={style.checkCircleIcon} alt="Verified" src="/checkcircle.svg" />
                                <div className={style.headingHelperText}>
                                    <h3 className={style.heading}>Verified</h3>
                                </div>
                            </div>
                            <div className={style.supportingText}>
                                You are successfully verified.
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FaceMatch;
